import { render, staticRenderFns } from "./JournalList.vue?vue&type=template&id=febe382a&scoped=true"
import script from "./JournalList.vue?vue&type=script&lang=js"
export * from "./JournalList.vue?vue&type=script&lang=js"
import style0 from "./JournalList.vue?vue&type=style&index=0&id=febe382a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "febe382a",
  null
  
)

export default component.exports